// extracted by mini-css-extract-plugin
export var label = "_3-2";
export var logo = "_3-1";
export var topNav = "_3-0";